<style  scoped>

.icon {
    display: inline-flex;
    align-self: center;
}

.icon svg, .icon img {
    height: 2rem;
    width: 2rem;
    fill: currentColor;
}

.icon.baseline svg, .icon img {
    top: .125em;
    position: relative;
}

h3 {
    margin:0 0 5px 0;
    padding:0;
    line-height:1;
    font-weight:normal;
  position:relative;
  color: #000;
}
/*H Tag Sizing*/


h3 {
  font-size: 15px;
}
.containercarousel_Image .style-3 ins {
    font-weight: 200;
    text-decoration: none;
    padding: 0px;
    margin:0px;
    color: #d93746;
}
.containercarousel_Image .blockdownInfo {
    -webkit-transition: .5s ease;
    transition: .5s ease;
    opacity: 1;
    position: relative;
    top: 0;
    left: 0;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    text-align: left;
}
.containercarousel_Image {
    position: relative;
    padding: 0px;
}
.icontext
{
  position:relative;
  top:-10px;
  left: -8px

}
.t-btn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.t-btn span:after {
  content: '\00bb';
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}

.t-btn:hover span {
  padding-right: 25px;
}

.t-btn:hover span:after {
  opacity: 1;
  right: 0;
}
@media screen and (max-width: 550px)
{
  .t-btn span:after {
    content: '';
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    transition: 0.5s;
  }
  .t-btn:hover span {
    padding-right: 0px;
  }
  .t-btn:hover span:after {
    opacity: 0;
    right: 0;
  }
  .icon svg, .icon img {
      height: 1.5rem;
      width: 1.5rem;
      fill: currentColor;
  }
  .icontext
  {
    position:relative;
    top:-5px;
    left: -5px

  }
  .text-center--sm
  {
     text-align: center;
  }
}
</style>

<template>

<div data-color="clear" class="js-header-panel worldSelect__noiseBg is-active c-nav-subsidiaries" style="background-color:#132148">
   <div class="c-nav__renderer__subsidiaries o-wrapper--panel u-fit u-backface-hidden js-render-panel"></div>
   <div class="c-nav-subsidiaries__overlay o-wrapper--panel u-fit u-bg--brand-dark"></div>
     <div class="c-page c-blog u-fit u-pad-x-w1of12 u-pad-x-w1of12@sm ">
        <section   data-color="clear"   class="u-relative   js-header-panel is-active u-pad-t-sm u-pad-t-ultra@sm">
            <div v-if="areThereCategories"  v-for="(postcat,topindex)  in pagecategories"  :data-index="topindex"  class="o-wrapper--valign  u-fit inspire-Custom-Container u-marg-x-auto u-marg-y-xs35 u-marg-y-sm@sm">
              <div class="u-fit-w" v-if="postcat.line===2">
                 <div class="t-text--md--bold u-marg-l-sm u-marg-r-sm privinvest-box-page t-text--md--bold@md u-relative">
                             <span class="c-home__section__upcomingprogram_title   c-inspire-title--color">
                                   <svg viewBox="0 0 280  15" >
                                       <text x="0" y="15" class="u-color--white--fill">{{postcat.namel2}}</text>
                                     </svg>
                               </span>
                    </div>
                </div>
    <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none is-active"></div>
        <div class="c-home__section__fade u-relative u-zindex--3 u-flex u-flex-fd--column@md  u-fit-w">
              <div class="c-team__content  u-marg-t-xxl u-marg-t-xl@xl  u-marg-t-lg@lg  u-marg-t-xxl@lg u-marg-t-lg@md u-w2of2" >
                  <section class="u-relative">
                    <div class="c-team__section-container u-relative  u-pad-y-lg@sm u-marg-x-sm ">
                        <div class="c-team__section">
                              <div class="u-flex u-flex-fw--wrap u-flex-jc--center">
                                  <a class="c-team__link  t-link u-pad-b-lg" target="_blank"  :class="{'isDisabled':post.Enable===false}"  :href="post.websitelink"  v-for="(post,index)  in SubsidiariesNav[postcat.id]"  :data-index="index"   :title="post.title" :id="(post.title).replace(/\s/g,'')"    @mouseover="onItemOver(index)"  @touchstart="onItemOver(index)"  >
                                      <!--<h2 class="t-h5 t-text--roman u-marg-b-xs u-color--white">{{post.titledesc}}</h2>-->
                                        <div class="c-team__link__photo-container js-photo-container u-relative o-box--1by3subsidiaries  u-overflow-h u-force-3d" >
                                              <div class="c-team__link__photo__overlay--middle u-absolute u-pos-t u-zindex--2"></div>
                                              <img class="c-team__link__photo  u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden" :id="(post.Stock_No).replace(/\s/g,'')"  :src="post.images[0].sizes.medium"     :alt="post.title"   ></img>
                                        </div>
                                      <div class=" u-pad-t-sm u-bg--Inspireblue" >
                                        <h4 class="t-text--sm  u-align-left  c-inspire-pcomingp---boxblue u-color--black">{{post.titledesc}}</h4>
                                         <!--<h4 class="t-text--sm  u-color--black   c-inspire-pcomingp---boxblue u-align-center">{{post.Stock_No}}</h4>-->
                                       </div>
                                       <div>
                                          <!--<h4 class="t-text--xs  u-align-left  c-inspire-pcomingp---boxblue-blog__article__date u-color--gray">{{post.Year}}</h4>
                                         <h4 class="t-text--xs  u-align-left  c-inspire-pcomingp---boxblue-blog__article__date u-color--gray">{{post.Stock_No}}</h4>-->
                                          <h4 class="t-text--xs  u-align-left   u-color--black  c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="post.first_paragraph_shorted" ></h4>
                                           <h4 class="t-text--xssub u-align-left   u-color--black  c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="post.websiteurl" ></h4>
                                        </div>
                                 </a>

                                </div>
                            </div>
                    </div>
                  </section>

              </div>
        </div>
      </div>
</section>

     </div>

</div>
</template>

<script>

import Pixi from 'pixi.js'
import tweenManager from 'pixi-tween'
import router from '../../application/router.js'
import {cubic}  from '../../utilities/cubic'
import {clamp}  from '../../utilities/clamp'
import {cubicu} from '../../utilities/cubicu'

import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import   CoreAjaxForm from     '../core-ajax-form/index.vue'


export default {
        components:
        {
                "app-sliced-text":AppSlicedText,
                "app-footer":AppFooter,
                'core-ajax-form':CoreAjaxForm


        },
    props:
    {
        adminContent:
        {
            type: Object,
            default: function() {}
        },
      debug:
      {
          type: Boolean,
          default: !1
      },
      isActive: {
          type: Boolean,
          default: !1
      },

        activePageIndex:
        {
            type: Number,
            default: 0
        }
        ,
        globalContent:
        {
            type: Object,
            default: function() {}
        },
        headerPageSize:
        {
              type: Array,
              default: function() {}
        }
    },
    watch: {
        isActive: "onActiveChangeSub"
    },
    data: function()
    {
        return {
          areTherePosts: !1,
         areThereCategories: !1,
         selectedOption:'',
         CarModel:Object(),
          popinContent: null,
          popinTitle: null,
           isPopinActive: !1,
           isPopinActivePhotos: !1,
           isButtonClicked:false,
           activeIndex: 0
        }
    }
    ,
    computed:
    {
        SubsidiariesNav: function()
       {
           return  this.adminContent.en.Subsidiaries
       },
      content: function()
       {
           return   this.globalContent
       },

          computedPostsCategories: function()
          {
                    var t = [];
                    if (this.SubsidiariesNav.categories)
                    {
                        this.areThereCategories = !0;
                        var   n = this.SubsidiariesNav.categories.length;
                        for (var e = 0;e < n; e += 1)
                        {
                            var r =  this.SubsidiariesNav.categories[e];
                             t.push(r)
                        }
                          this.popinContent =   this.SubsidiariesNav[t[0].id][0]
                    }
                    else
                    {
                     this.areThereCategories = !1,
                     t.push({
                        title: "Error - Page not found",
                        first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                        dateFormated: {
                            day: 404,
                            month: "",
                            year: ""
                        }
                    })
                  }
                  return t
    }  ,
    computedPages: function()
   {
        var t = [];
        t.length = 0;
            for (var e = 0, n = Object.keys(this.SubsidiariesNav).length; e < n; e += 1)
            {
                var r = Object.keys(this.SubsidiariesNav)[e];
                t.push({
                    index: parseInt(r, 10),
                    isVisible: !0
                })
            }
            return t
      }
  },
    created: function()
    {
        this._inAnimRatio = 0,
        this._outAnimRatio = 0,
        this._currInAnimRatio = 0,
        this._currOutAnimRatio = 0,
        this._sceneWidth = 1600,
        this._sceneHeight = 900,
        this._direction = 1,
        this._translationIndex = 0,
        this._isRendering = !1,
        this._draw = 0,
        this.onResize = this.onResize.bind(this),
        this.onEnterframe = this.onEnterframe.bind(this),
        this.eventHub.$on("resize", this.onResize),
        this.eventHub.$on("enterframe", this.onEnterframe),

        this.pages = this.computedPages,
        this.pagecategories =this.computedPostsCategories,
        this.eventHub.$on("close:popin", this.onClosePopin),
        this.eventHub.$on("resize", this.onResize)
    },
    mounted: function()
    {

        this.$renderPanel = this.$el.querySelector(".js-render-panel"),
        console.log("this.eventHub"+this.eventHub);
        this.eventHub.$emit("page:readynscroll"),
        this.loadTextures(),
        this.onActiveChangeSub();
        //window.matchMedia("(min-device-width: 1000px) and (min-device-height: 850px)").matches?this.eventHub.$emit("disable:scroll"):'',
        if(window.matchMedia("(max-width: 775px)").matches)
        {
          console.log("emit enable:scroll");
          this.eventHub.$emit("enable:scroll")
        }
        else {
          console.log("emit disable:scroll");
          this.eventHub.$emit("disable:scroll");
        }


    },
    destroyed: function()
    {
        this.eventHub.$off("resize", this.onResize),
        this.eventHub.$off("enterframe", this.onEnterframe),
        this.eventHub.$off("close:popin", this.onClosePopin),
        this._stage.destroy(!0)
    },
    methods:
    {
                loadTextures: function()
                {
                      var t = this;
                      t.initScene()
                  },
                   initScene: function()
                   {
                       this._renderer = PIXI.autoDetectRenderer(1450,900,{   backgroundColor:0x132148, antialias: !1 }),
                       this._tilesContainer = new PIXI.Container(),
                        this._secondaryTilesContainer = new PIXI.Container(),
                        this._spritesContainer = new PIXI.Container(),
                        this._textContainer = new PIXI.Container(),
                         this._allTilesContainer = new PIXI.Container(),
                          this._container = new PIXI.Container(),
                          this.$renderPanel.appendChild(this._renderer.view),
                          //this._tilesContainer.position.x = .5 * -this.$root.winWidth,
                          this._tilesContainer.position.x = .5 * -this.$root.winWidth,

                          this._stage = new PIXI.Container(),
                          this._stage.addChild(this._tilesContainer),
                          this._stage.addChild(this._allTilesContainer),
                          this._stage.addChild(this._spritesContainer),
                          this._stage.addChild(this._secondaryTilesContainer),
                          this._stage.addChild(this._textContainer),
                           this._stage.addChild(this._container),
                           this._allTilesContainer.addChild(this._tilesContainer),
                           this._allTilesContainer.addChild(this._secondaryTilesContainer),
                           this._container.addChild(this._allTilesContainer),

                           this._rotation = 0,
                           this.initTiles(),
                           this.initSprites()
                   },
                   initTiles: function()
                   {

                       this._topTiles = new Array(),
                       this._bottomTiles = new Array(),
                       this._tiles = new Array();
                       for (var t = 0; t < this.content.subsidiariesslide.links.length + 2; t++)
                       this._tiles.push({
                           graphic: new PIXI.Graphics(),
                           bgGraphic: new PIXI.Graphics(),
                           x: 0,
                           y: 0,
                           w: 0,
                           h: 0
                       }),
                       this._tilesContainer.addChild(this._tiles[t].graphic),
                        this._tilesContainer.addChild(this._tiles[t].bgGraphic);
                       for (var e = 0; e < this.content.subsidiariesslide.links.length + 1; e++)
                        this._topTiles.push({
                           graphic: new PIXI.Graphics(),
                           x: 0,
                           y: 0,
                           w: 0,
                           h: 0
                       }),
                        this._bottomTiles.push({
                           graphic: new PIXI.Graphics(),
                           x: 0,
                           y: 0,
                           w: 0,
                           h: 0
                       }),
                       this._secondaryTilesContainer.addChild(this._topTiles[e].graphic),
                        this._secondaryTilesContainer.addChild(this._bottomTiles[e].graphic);
                       this._tweenX =PIXI.tweenManager.createTween(this._tilesContainer),
                        this._tweenXInversed =PIXI.tweenManager.createTween(this._secondaryTilesContainer),
                         this._tweenTextX = PIXI.tweenManager.createTween(this._textContainer),
                         this._tweenSpritesContainer =PIXI.tweenManager.createTween(this._spritesContainer),
                          this.drawTiles()
                   },
                   initSprites: function()
                   {
                       var t = this;
                       this._backgrounds = new Array();
                       for (var e = 0; e < this.content.subsidiariesslide.links.length; e++)
                       {
                           var n = PIXI.Texture.fromImage(this.content.subsidiariesslide.links[e].image.src),
                               r = new PIXI.Sprite(n);
                           this._backgrounds.push({
                               sprite: r,
                               tween: PIXI.tweenManager.createTween(r),
                               w: this.content.subsidiariesslide.links[e].image.width,
                               h: this.content.subsidiariesslide.links[e].image.height,
                               isAnimating: !1,
                               animAlphaRatio: 0,
                               currAnimAlphaRatio: 0
                           }),
                            this._spritesContainer.addChild(this._backgrounds[e].sprite),
                            this._container.addChild(this._spritesContainer),
                             this._backgrounds[e].sprite.alpha = 0
                       }
                       setTimeout(function() {
                           t.onResize()
                       }, 150)
                   },
                   onResize: function()
                   {

                     if(window.matchMedia("(max-width: 775px)").matches)
                     {
                       console.log("emit enable:scroll");
                       this.eventHub.$emit("enable:scroll")
                     }
                     else {
                       console.log("emit disable:scroll");
                       this.eventHub.$emit("disable:scroll");
                     }
                    this.debug&& console.log("App-nav-onResize call start");
                       if (this._renderer && this._backgrounds)
                        {
                              var  t = this.$root.winWidth,
                               e = this.$root.winHeight,
                               n = this._sceneWidth / this._sceneHeight,
                               r = t / n > e,
                               i = r ? t : e * n,
                               s = r ? t / n : e,
                               o = i / this._sceneWidth,
                               a = .5 * (i - this._sceneWidth) - .5 * (i - t),
                               u = .5 * (s - this._sceneHeight) - .5 * (s - e);
                             this._renderer.view.style.transform = "translateX(" + a + "px) translateY(" + u + "px) scale(" + o + ")";
                             for (var l = 0; l < this._backgrounds.length; l++)
                             this._backgrounds[l].sprite.width = this._sceneWidth + .35 * this._sceneWidth,
                             this._backgrounds[l].sprite.height = this._sceneHeight + .35 * this._sceneHeight;

                             this._renderer.resize(this._sceneWidth, this._sceneHeight)
                             this.debug&&console.log("App-nav-onResize call start Rendered start aftter call resize");
                       }
                   },
                   drawTiles: function()
                   {
                     var t = this.$root.winWidth, e = this._sceneHeight;
                         for (var  n = 0; n < this._tiles.length; n++)
                         {
                             var r = .3 * t * n + 1 * (n + 1),
                                // i = .35 * e * .5,
                                 i = 300,
                                 //s = .7 * t,
                                 s =  1.5*t,
                                 o =  e;
                           this._tiles[n].graphic.clear(),
                           this._tiles[n].graphic.beginFill(0x132148),
                           this._tiles[n].graphic.drawRect(r, i, s, o),
                           this._tiles[n].graphic.endFill(),
                           this._tiles[n].bgGraphic.clear(),
                           this._tiles[n].bgGraphic.beginFill(0x132148),
                           this._tiles[n].bgGraphic.drawRect(r, i, s, o),
                           this._tiles[n].bgGraphic.endFill()
                       }
                       for (var a = 0; a < this._topTiles.length; a++)
                        {
                          this.debug&&console.log("go inside draw tiles _topTiles:"+a);
                           var u = .7 * t * a + 2 * (a + 1),
                               l = .7 * t,
                               c = .55 * e;
                           this._topTiles[a].graphic.clear(),
                           this._topTiles[a].graphic.beginFill(0x132148),
                           this._topTiles[a].graphic.drawRect(u, 75 - c, l, c),
                           this._topTiles[a].graphic.endFill(),
                           this._bottomTiles[a].graphic.clear(),
                           this._bottomTiles[a].graphic.beginFill(0x132148),
                            this._bottomTiles[a].graphic.drawRect(u, e - 75, l, c),
                            this._bottomTiles[a].graphic.endFill()
                       }
                       this._secondaryTilesContainer.position.x = -.5 * t * (this._tiles.length - 1)
                   },
                   onEnterframe: function()
                   {

                     if (this._isRendering)
                    {
                        this.debug&&console.log("Nav On Enter Frame");
                        PIXI.tweenManager.update();
                        for (var t = 0; t < this._backgrounds.length; t++)
                        this._backgrounds[t].isAlphaAnimating && this._backgrounds[t].animAlphaRatio < 1

                        ?
                         this._backgrounds[t].animAlphaRatio += .015

                         :
                         !this._backgrounds[t].isAlphaAnimating && this._backgrounds[t].animAlphaRatio > 0 && (this._backgrounds[t].animAlphaRatio -= .025),
                         this._backgrounds[t].currAnimAlphaRatio = (0, clamp)(this._backgrounds[t].animAlphaRatio, 0, 1),
                         this._backgrounds[t].sprite.alpha = 1 * this._backgrounds[t].currAnimAlphaRatio;

                         this._isRedirecting && this._inAnimRatio <= 1
                         ?
                         (this._inAnimRatio += .015, this._currInAnimRatio = cubicu((0, clamp)(this._inAnimRatio, 0, 1)),
                          //console.log("this._currInAnimRatio :" + this._currInAnimRatio),
                         this._container.rotation = this._rotation - this._rotation * this._currInAnimRatio,
                         this._container.position.y = .3 * -this._sceneHeight + .3 * this._sceneHeight * this._currInAnimRatio,
                         this._allTilesContainer.scale.x = 1 + .55 * this._currInAnimRatio, this._allTilesContainer.scale.y = 1 + .55 * this._currInAnimRatio,
                          this._allTilesContainer.position.x = .525 * -this._sceneWidth * this._currInAnimRatio,
                           this._allTilesContainer.position.y = -.275 * this._sceneHeight * this._currInAnimRatio,
                         this._spritesContainer.scale.x = 1 - .2 * this._currInAnimRatio,
                         this._spritesContainer.scale.y = 1 - .2 * this._currInAnimRatio)
                          :
                           this._isAnimating && (
                           this._outAnimRatio += .015,
                           this._currOutAnimRatio =  cubicu((0, clamp)(this._outAnimRatio, 0, 1)),
                           //console.log("this._currOutAnimRatio :"+this._currOutAnimRatio),
                           this._container.rotation = this._rotation * this._currOutAnimRatio,
                            this._container.position.y = .3 * -this._sceneHeight + .3 * this._sceneHeight - .3 * this._sceneHeight * this._currOutAnimRatio,
                            this._allTilesContainer.scale.x = 1.55 - .55 * this._currOutAnimRatio,
                           this._allTilesContainer.scale.y = 1.55 - .55 * this._currOutAnimRatio,
                           this._allTilesContainer.position.x = .525 * -this._sceneWidth + .525 * this._sceneWidth * this._currOutAnimRatio,
                           this._allTilesContainer.position.y = -.275 * this._sceneHeight - -.275 * this._sceneHeight * this._currOutAnimRatio,
                           this._spritesContainer.scale.x = .8 + .2 * this._currOutAnimRatio,
                            this._spritesContainer.scale.y = .8 + .2 * this._currOutAnimRatio),
                           this._outAnimRatio > 1 && (this._isAnimating = !1)//,
                           this._renderer.render(this._stage)
                      }
                   },
                   setInitialState: function()
                   {
                     this._container.rotation = this._rotation,
                      this._spritesContainer.alpha = 1,
                      this._container.position.y = .3 * -this._sceneHeight + .3 * this._sceneHeight,
                      //this._tilesContainer.position.x = -(.7 * this._sceneWidth + 1) * this.activeIndex + .5 * -this._sceneWidth,
                      this._tilesContainer.position.x = .5 * -this._sceneWidth,
                      this._secondaryTilesContainer.position.x = -.3 * this._sceneWidth * (this._tiles.length - 1 - this.activeIndex) + .5 * this._sceneWidth,
                      this._allTilesContainer.scale.x = 1.55,
                      this._allTilesContainer.scale.y = 1.55,
                      this._allTilesContainer.position.x = .525 * -this._sceneWidth,
                      this._allTilesContainer.position.y = -.275 * this._sceneHeight,
                       this._spritesContainer.scale.x = .8,
                        this._spritesContainer.scale.y = .8;
                     for (var t = 0; t < this._backgrounds.length; t++)
                      this._backgrounds[this.activeIndex].sprite.alpha = 0;
                     this._backgrounds[this.activeIndex].sprite.mask = this._tiles[this._translationIndex + 1].graphic
                   },
                   onItemOver: function(t) {
                     //console.log(t);
                        var e = this;
                       //console.log(e);
                      // console.log(e._backgrounds[t]);
                       if (!this._isRedirecting) {
                           if (this._isAnimating) return void setTimeout(function() {
                               e.onItemOver(t)
                           }, 50);
                           clearTimeout(n);
                           var n = setTimeout(function() {
                               t > e.activeIndex
                                ?
                                (e._direction = 1, e._translationIndex += e._direction, e.translateSprite(e._backgrounds[t].tween, t))
                                :
                                 t < e.activeIndex && (e._direction = -1, e._translationIndex += e._direction, e.translateSprite(e._backgrounds[t].tween, t)),
                               e._diffIndex = Math.abs(e.activeIndex - t),
                                e._backgrounds[e.activeIndex].isAlphaAnimating = !1,
                                 e._backgrounds[t].isAlphaAnimating = !0,
                                 e.activeIndex = t,
                                 e._backgrounds[e.activeIndex].sprite.mask = e._tiles[e._translationIndex + 1].graphic,
                                  e.translateTilesContainer(PIXI.tween.Easing.linear()),
                                  e.translateInversedTilesContainer()
                           }, 150)
                       }
                   },
                   onItemClick: function(t)
                   {

                   },
                   onActiveChangeSub: function()
                    {

                      var t = this;
                      clearTimeout(this._timerActive), clearTimeout(this._timerInactive),
                       this.isActive ? (this._isRendering = !0,
                         this.$el.classList.remove("is-leaving"),
                        this._isRedirecting = !1,
                        this._outAnimRatio = 0,
                        this.$el.style.display = "block",
                        this.activeIndex = 0,//this.activePageIndex,
                         this._translationIndex = 0,//this.activePageIndex,
                         this._backgrounds[this.activeIndex].isAlphaAnimating = !0,
                         this.eventHub.$emit("disable:scroll"),
                          this.setInitialState(),
                          this._timerActive = setTimeout(function()
                          {
                          t.$el.classList.add("is-active"), t._isAnimating = !0
                      }, 50)) : (this.activeIndex === this.activePageIndex && this.$el.classList.add("is-same-page"), this._isAnimating = !1, this._isRedirecting = !0, this._inAnimRatio = 0, this.$el.classList.add("is-leaving"), this.$el.classList.remove("is-active"),
                      this._timerInactive = setTimeout(function() {
                          t._isRendering = !1, t.$el.style.display = "none", t.$el.classList.remove("is-same-page"), t._outAnimRatio = 0
                      }, this.activeIndex === this.activePageIndex ? 2300 : 2e3))


                   },
                   translateSprite: function(t, e)
                   {
                     t.stop().clear(),
                     t.time = 2700,
                     t.easing = PIXI.tween.Easing.outQuint(), t.from({
                         x: this._backgrounds[e].sprite.position.x + .3 * this._sceneWidth * this._direction
                     }), t.to({
                         x: 0
                     }), t.loop = !1, t.start()
                   },
                   translateTilesContainer: function(t)
                   {
                       this._tweenX.stop().clear(),
                       this._tweenX.time = 2500,
                       this._tweenX.easing = PIXI.tween.Easing.outQuart(),
                       this._tweenX.from({
                         x: this._tilesContainer.position.x
                     }),
                      this._tweenX.to({
                         x: -(.3 * this._sceneWidth + 1) * this._translationIndex + .5 * -this._sceneWidth
                     }), this._tweenX.loop = !1, this._tweenX.start()
                   },
                   translateInversedTilesContainer: function(t)
                   {
                     this._tweenXInversed.stop().clear(),
                     this._tweenXInversed.time = 2e3,
                     this._tweenXInversed.easing = PIXI.tween.Easing.outQuart(),
                     this._tweenXInversed.from({
                        x: this._secondaryTilesContainer.position.x
                    }), this._tweenXInversed.to({
                        x: -.3 * this._sceneWidth * (this._tiles.length - 1 - this._translationIndex) + .5 * this._sceneWidth
                    }), this._tweenXInversed.loop = !1, this._tweenXInversed.start()
                   }
               }
}

</script>
